import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../../../generic-components/Button';
import { ACTION_TYPES } from '../../constants';

const STYLES = {
  PERSONAL_CTA:
    'bg-bw00 text-action03 border-action03 border-[1px] hover:border-action04 hover:text-action04 w-[145px] h-[42px] rounded-[3.77px] font-metricRMedium text-sm',
  BUSINESS_CTA:
    'bg-action03 hover:bg-action04 text-bw00 w-[145px] h-[42px] rounded-[3.77px] font-metricRMedium text-sm mr-[25px]',
};

interface ICategorizationPanel {
  handleActionClick: (actionType: string) => void;
}

export const CategorizationPanel = ({ handleActionClick }: ICategorizationPanel) => {
  const { t } = useTranslation();
  return (
    <div className='w-full h-[46px] flex items-center justify-center'>
      <Button
        className={STYLES.BUSINESS_CTA}
        title={t('MARK_AS_BUSINESS')}
        id='setMarkAsBusinessCta'
        testId='CatPanelMarkAsBusiness'
        onClick={() => handleActionClick(ACTION_TYPES.WORK)}
      />
      <Button
        className={STYLES.PERSONAL_CTA}
        title={t('MARK_AS_PERSONAL')}
        id='setMarkAsPersonalCta'
        testId='CatPanelMarkAsPersonal'
        onClick={() => handleActionClick(ACTION_TYPES.LIFE)}
      />
    </div>
  );
};
